import { useClient } from 'shared';
import { TProviderRecentlyWorked } from './types';

export const useWorkersForReview = () =>
    useClient<TProviderRecentlyWorked[]>({
        url: 'api/provider-review/eligible-for-review/',
    });
